<template>
  <section>
    <div class="block">
      <div
        class="w-full relative min-h-screen sm:hidden" id="panaromaimg"
        v-bind:style="{ height: dynamicHeight + 'px' }"
      >
        <div
          class="h-screen sticky top-0 w-full overflow-x-hidden"
          ref="panaromaContainer"
        >
          <div
            class="absolute h-full horizontal-scroll"
            v-bind:style="{
              transform: 'translateX(' + translateXscroll + 'px)',
            }"
            ref="panaromaSlide"
          >
            <div class="relative h-full flex flex-nowrap justify-start">
              <img
                class="relative flex-shrink-0 img-width"
                :src="require('../assets/panaroma/shogun-2.jpg')"
                alt=""
              />

              <img
                class="relative flex-shrink-0 img-width"
                :src="require('../assets/panaroma/shogun-3.jpg')"
                alt=""
              />

              <img
                class="relative flex-shrink-0 img-width"
                :src="require('../assets/panaroma/shogun-4.jpg')"
                alt=""
              />

              <img
                class="relative flex-shrink-0 img-width"
                :src="require('../assets/panaroma/shogun-5.jpg')"
                alt=""
              />
              <img
                class="relative flex-shrink-0 img-width"
                :src="require('../assets/panaroma/shogun-6.jpg')"
                alt=""
              />
              <img
                class="relative flex-shrink-0 img-width"
                :src="require('../assets/panaroma/shogun-7.jpg')"
                alt=""
              />
              <img
                class="relative flex-shrink-0 img-width"
                :src="require('../assets/panaroma/shogun-8.jpg')"
                alt=""
              />
              <img
                class="relative flex-shrink-0 img-width"
                :src="require('../assets/panaroma/shogun-9.jpg')"
                alt=""
              />
              <img
                class="relative flex-shrink-0 img-width"
                :src="require('../assets/panaroma/shogun-10.jpg')"
                alt=""
              />
              <img
                class="relative flex-shrink-0 img-width"
                :src="require('../assets/panaroma/shogun-11.jpg')"
                alt=""
              />
              <img
                class="relative flex-shrink-0 img-width"
                :src="require('../assets/panaroma/shogun-12.jpg')"
                alt=""
              />
              <img
                class="relative flex-shrink-0 img-width"
                :src="require('../assets/panaroma/shogun-13.jpg')"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <div class="clear-both"></div>
    </div>
  </section>
</template>

<script>
import _ from "lodash";

export default {
  data() {
    return {
      dynamicHeight: 0,
      translateXscroll: 0,
      panaromaEl: "",
      panaromaContainer: ""
    };
  },
  emits: ["scroll"],
  computed: {},

  methods: {
    setScroll() {
      let offsetTop = this.panaromaContainer.offsetTop;

      //const offsetTop = 100
      this.translateXscroll = -offsetTop;
      console.log("scroll offsettop" + offsetTop);
      console.log("object width " + this.dynamicHeight);
    },
    resizeHandler() {
      this.objectWidth =
        this.$refs.panaromaSlide.scrollWidth == 0
          ? this.objectWidth
          : this.panaromaEl.scrollWidth;
      console.log(this.$refs.panaromaSlide.offsetWidth);
      //let objectWidth =  1920
      const vw = window.innerWidth;
      const vh = window.innerHeight;
      this.dynamicHeight = this.objectWidth - vw + vh;
      this.$store.commit("setPanaromaHeight", this.dynamicHeight);
    }
  },

  mounted() {
    this.panaromaEl = this.$refs.panaromaSlide;
    this.panaromaContainer = this.$refs.panaromaContainer;

    setTimeout(this.resizeHandler, 2000);
    window.addEventListener("scroll", _.throttle(this.setScroll, 300));
    window.addEventListener("load", this.resizeHandler);
    window.addEventListener("resize", this.resizeHandler);

    //console.log(this.$refs.panaromaSlide);
    //this.resizeHandler();
  }
};
</script>

<style scoped>
.horizontal-scroll {
  will-change: transform;
}
</style>